import { axiosInstance } from 'boot/axios.js'

export async function query(ctx, queryParams = {}) {
  try {
    const response = await axiosInstance({
      url: 'tyre-families',
      method: 'GET',
      params: queryParams
    })
    ctx.commit('items', response.data.items)
    ctx.commit('pagination', response.data.pagination)
    return response
  } catch (e) {
    throw e
  }
}

export async function queryMotorcycles(ctx, params) {
  try {
    const response = await axiosInstance({
      url: 'motorcycles/tyre-families/',
      method: 'get',
      params: params
    })
    ctx.commit('items', response.data.items)
    ctx.commit('pagination', response.data.pagination)
    return response
  } catch (e) {
    throw e
  }
}

export async function queryB2bOff(ctx, params) {
  try {
    const response = await axiosInstance({
      url: 'b2b-off/tyre-families/',
      method: 'get',
      params: params
    })
    ctx.commit('items', response.data.items)
    ctx.commit('pagination', response.data.pagination)
    return response
  } catch (e) {
    throw e
  }
}

export async function queryBike(ctx, params) {
  try {
    const response = await axiosInstance({
      url: 'bikes/tyre-families/',
      method: 'get',
      params: params
    })
    ctx.commit('items', response.data.items)
    ctx.commit('pagination', response.data.pagination)
    return response
  } catch (e) {
    throw e
  }
}

export async function get(ctx, queryParams = {}) {
  try {
    const response = await axiosInstance({
      url: parseUrl('tyre-families', queryParams),
      method: 'GET',
      params: queryParams
    })
    ctx.commit('item', response.data)
    return response
  } catch (e) {
    throw e
  }
}

function parseUrl(state, params) {
  if (state && params.id) {
    return '/' + state + '/' + params.id
  }
  return '/' + state
}
